<template>
  <div class="button-report dropdown">
    <div class="btn-group">
      <button
        class="btn btn-icon btn-icon-left"
        :class="{ [buttonClass]: true, loading: running }"
        @click="run"
        :disabled="disabled || running"
      >
        <slot
          v-bind:option="currentOption"
          v-bind:icon="defaults.icon"
          v-bind:label="defaults.label"
        >
          <fa-icon :icon="defaults.icon"></fa-icon>
          <span>{{ defaults.label }}</span>
          <span
            class="ml-1"
            v-if="hasOptions && currentOption"
          >({{ currentOption.text }})</span>
        </slot>
      </button>
      <template v-if="hasOptions && !disabled">
        <a
          class="btn dropdown-toggle"
          :class="buttonClass"
          tabindex="0"
        ><i class="icon icon-caret"></i></a>
        <ul class="menu">
          <li
            class="menu-item"
            v-for="item in defaults.options"
            :key="item.value"
            @click="setCurrentOption(item)"
          ><a class="c-hand">{{ item.text }}</a></li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import localforage from 'localforage';

export default {
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'pdf',
    },
    route: {
      type: String,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    buttonClass: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      running: false,
      currentOption: null,
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    defaults() {
      switch (this.type.toLowerCase()) {
        case 'pdf':
          return {
            label: 'Imprimir',
            icon: ['fal', 'print'],
            options: [
              { value: 'a4', text: 'A4' },
              { value: 'a5', text: 'A5' },
            ],
          };
        case 'sheet':
          return {
            label: 'Gerar planilha',
            icon: ['fal', 'file-excel'],
            options: null,
          };
        case 'csv':
          return {
            label: 'Gerar CSV',
            icon: ['fal', 'file-csv'],
            options: null,
          };
        default:
          return {
            label: 'Relatório',
            icon: ['fal', 'file'],
            options: null,
          };
      }
    },
    hasOptions() {
      return this.defaults.options
        && Array.isArray(this.defaults.options)
        && this.defaults.options.length > 0;
    },
    storageKey() {
      return [
        'report',
        this.$route.path,
        this.type,
      ].join('/').replace(/\/\//g, '/');
    },
  },
  methods: {
    async init() {
      if (this.hasOptions) {
        let option;

        const value = await localforage.getItem(this.storageKey).catch(() => null);
        if (value) {
          option = this.defaults.options.find(item => item.value === value);
        }

        if (!option) {
          [option] = this.defaults.options;
        }

        this.setCurrentOption(option);
      }
    },
    setCurrentOption(option) {
      this.currentOption = option;
      localforage.setItem(this.storageKey, option ? option.value : '');
    },
    async run() {
      if (this.running) return;

      this.running = true;
      try {
        const type = this.type.toLowerCase();

        const params = {
          ...this.params,
          reportType: this.currentOption
            ? `${type}:${this.currentOption.value}`
            : type,
        };

        if (type === 'pdf') {
          await this.$file.print(this.route, params, this.options);
        } else {
          await this.$file.download(this.route, params, this.options);
        }
      } catch (e) {
        //
      } finally {
        this.running = false;
      }
    },
  },
};
</script>

<style lang="scss">
.button-report {
  .menu {
    min-width: 100%;
    .menu-item {
      text-align: right;
    }
  }
}
</style>
